import { ServiceCode } from '../enums/serviceCode';

export const serviceCodeButtonOrder = [
    ServiceCode.GGZCg,
    ServiceCode.GGZCt,
    ServiceCode.GGZCtriage,
    ServiceCode.GGZCf2f,
    ServiceCode.GGZCmdo,
];
